/* eslint-disable import/prefer-default-export */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { createProductDraftFromMaster } from './createProductDraftFromMaster';
import { createVariantDraftFromMaster } from './createVariantDraftFromMaster';
import { getProductChannel } from './helpers/channelHelpers';
import { showDraftForChannelToast } from './helpers/showDraftForChannelToast';

/**
 * Orchestration-only thunk: no own reducer, SDK calls, or Toast.
 * Routes single-variant draft sync through createProductDraftFromMaster
 * or createVariantDraftFromMaster per channel state.
 */
export const syncSingleVariantToDraft = createAsyncThunk(
  'products/syncSingleVariantToDraft',
  async ({
    productId,
    channelIds,
    masterVariantId,
    draftMedia = {},
    overrideExisting = false,
  }, { dispatch, getState, extra: { Toast } }) => {
    const product = getState().products.items.find(({ _id }) => _id === productId);
    const productsState = getState().products;
    const variantDraftMedia = { ...draftMedia, isVariantSync: true };

    await Promise.all(channelIds.map(async (channelId) => {
      const listingProduct = getProductChannel(product, channelId, productsState)?.listingProduct;

      if (!listingProduct) {
        await dispatch(createProductDraftFromMaster({
          productId,
          channelIds: [channelId],
          masterVariantIds: [masterVariantId],
          draftMedia: variantDraftMedia,
          overrideExisting,
          suppressToast: true,
        })).unwrap();
        return;
      }

      await dispatch(createVariantDraftFromMaster({
        productId,
        channelIds: [channelId],
        masterVariantIds: [masterVariantId],
        draftMedia: variantDraftMedia,
        overrideExisting,
        suppressToast: true,
      })).unwrap();
    }));

    const { user: { team } } = getState();
    showDraftForChannelToast({
      Toast,
      channelIds,
      salesChannels: team?.salesChannels || [],
    });

    return { productId, channelIds, masterVariantId };
  },
);
